/* eslint-disable no-param-reassign */
import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
// core
import {
  Button, Divider, FormControlLabel, Switch, Grid, TextField,
} from '@material-ui/core';

import {
  DragIndicator, Edit, ExpandLess, ExpandMore,
  VisibilityOutlined,
} from '@material-ui/icons';

import {
  DragDropContext, Droppable, Draggable,
} from 'react-beautiful-dnd';
import { useLocation, useHistory } from 'react-router-dom';
import useStyles from './styles';
import { CategoryOptionsProvider } from '../../../../components/Pages/QuestionShell/CategoryOptionsContext';

// const
import {
  DROP_DOWN_MENU, END_PAGE, LONG_ANSWER, SIMPLE_SELECTION,
  SATISFACTION, SHORT_ANSWER, MULTIPLE_SELECTION, WELCOME_PAGE,
  YES_NO_QUESTION, NUMERIC_ANSWER, DATE, NPS_QUESTION, CONTENT,
  MULTIPLE_IMAGE_QUESTION, SIGNATURE_QUESTION, BARCODE_QUESTION,
  DECIMAL_ANSWER, PRICE, VIDEO, TIME,
  FORMATTED_ANSWER, USER_SELECTION,
} from '../../../../utils/const/pageTypes';
import UserSelection from '../../../../components/Pages/UserSelection';

import { EDIT_MODE } from '../../../../utils/const/taskModes';

import {
  AUDIO, AUDIO_BACKGROUND, IMAGE, RESUME_PAGE,
} from '../../../../utils/const/questions';

// components
import SelectPage from '../../../../components/Pages/SelectPage';
import WelcomePage from '../../../../components/Pages/WelcomePage';
import ResumePage from '../../../../components/Pages/ResumePage';
import SimpleSelection from '../../../../components/Pages/SimpleSelection';
import MultipleSelection from '../../../../components/Pages/MultipleSelection';
import ShortAnswer from '../../../../components/Pages/ShortAnswer';
import DropDownMenu from '../../../../components/Pages/DropDownMenu';
import LongAnswer from '../../../../components/Pages/LongAnswer';
import Satisfaction from '../../../../components/Pages/Satisfaction';
import ImagesAnswer from '../../../../components/Pages/ImageAnswer';
import NumericAnswer from '../../../../components/Pages/NumericAnswer';
import Snackbar from '../../../../components/Snackbar';
import DateAnswer from '../../../../components/Pages/DateAnswer';
import QuestionLogic from '../../../QuestionLogic';
import YesNoQuestion from '../../../../components/Pages/YesNoQuestion';
import NpsQuestion from '../../../../components/Pages/NpsQuestion';
import MultipleImageQuestion from '../../../../components/Pages/MultipleImageQuestion';
import SignatureQuestion from '../../../../components/Pages/SignatureQuestion';
import BarcodeQuestion from '../../../../components/Pages/BarcodeQuestion';
import TaskSettings from '../../TaskSettings';
import questionValidator from '../../../../utils/questionsValidator';
import {
  normalizeQuestionLogic,
  remapIdentifierAfterDelete,
  removeQuestionAndRewireLogic,
} from '../../../../utils/questionLogic';
import DecimalAnswer from '../../../../components/Pages/DecimalAnswer';
import Price from '../../../../components/Pages/Price';
import Video from '../../../../components/Pages/Video';
import Audio from '../../../../components/Pages/Audio';
import Time from '../../../../components/Pages/Time';
import { PRODUCT, INVENTORY } from '../../../../utils/const/formTypes';

// requests
import { postNewSurvey, getSurveys, getSurveysByType } from '../../../../requests/api/survey';
import { createQuestionGuideline } from '../../../../requests/api/question-guideline';
import sleep from '../../../../utils/sleep';
import FormattedAnswer from '../../../../components/Pages/FormattedAnswer';

// parametros de state necesarios:
// projectId: id del proyecto
// projectName: nombre del proyecto
// taskName: nombre de la tarea
// typeName: nombre del formulario
// typeValue: id del formulario
function CreateTask() {
  const styles = useStyles();
  const { t } = useTranslation();
  const taskURLPath = '/tasks';
  const history = useHistory();
  const location = useLocation();
  // TODO: eliminar las variables que no son necesarias
  const {
    projectId,
    projectName,
    taskName,
    typeName,
    typeValue,
  } = location.state || {};

  const project = {
    name: projectName,
    value: projectId,
  };
  // TODO: buscar mejor manera de bloquear el boton
  let createButtonBlocked = false;

  // snackbar status
  const [message, setMessage] = useState('');
  const [verticalForm, setVerticalForm] = useState(false);
  const [severity, setSeverity] = useState('');
  const [switchStock, setSwitchStock] = useState(null);
  const [maxDistance, setMaxDistance] = useState(0);
  const [needReview, setNeedReview] = useState(0);

  const [inputValues, setInputValues] = useState({
    title: taskName,
    type: { name: typeName, value: typeValue },
    project: { name: '', value: '' },
  });

  const formType = inputValues.type;

  const [valuesProp, setValuesProp] = useState({
    isSwitchStock: false,
    productInformation: false,
  });

  const [openConfigs, setOpenConfigs] = useState(false);
  const [georeference, setGeoreference] = useState(true);
  const [aiAnalysisRequired, setAiAnalysisRequired] = useState(false);
  const [viewDetail, setViewDetail] = useState(null);
  const generalView = false;

  const [pages, setPages] = useState([
    {
      identifier: 0,
      hiddenIdentifier: 0,
      type: null,
      name: '',
      required: false,
    },
  ]);

  // const [tab, setTab] = useState(0);
  const [selectedPage, setSelectedPage] = useState(null);

  const [openConnections, setOpenConnections] = useState(false);
  const [teleauditQuestionOptions, setTeleauditQuestionOptions] = useState([]);
  const [revisionPolicy, setRevisionPolicy] = useState({
    name: t('task.taskEdition.revisionPolicy.placeholder'),
    value: '',
  });

  const [surveyLabel, setSurveyLabel] = useState({
    name: t('task.taskForm.withoutLabel'),
    value: '',
  });

  const [isSurveyTeleaudit, setIsSurveyTeleaudit] = useState({
    name: t('task.taskEdition.revisionPolicy.placeholder'),
    value: '',
  });

  const [executionSurveyId, setExecutionSurveyId] = useState({ name: '', value: null });
  const [reviewSurveyId, setReviewSurveyId] = useState({ name: '', value: null });
  const [executionSurveyOptions, setExecutionSurveyOptions] = useState([]);
  const [reviewSurveyOptions, setReviewSurveyOptions] = useState([]);
  // Change the tool tab
  // const handleChangeTab = (event, newTab) => {
  //   setTab(newTab);
  // };

  useEffect(() => {
    const requestSearch = async () => {
      const response = await getSurveys();
      if (response.data?.data?.surveys) {
        const options = [
          { name: 'Seleccione Opcion', value: '' },
          ...response.data.data.surveys.map((survey) => ({ name: survey.title, value: survey.id })),
        ];
        setTeleauditQuestionOptions(options);
      }

      const executionResponse = await getSurveysByType('execution');
      const reviewResponse = await getSurveysByType('review');
      const executionOptions = [
        { name: 'Seleccione Encuesta de Ejecución', value: null },
        ...(executionResponse.data?.data?.surveys || []).map((survey) => (
          { name: survey.title, value: survey.id }
        )),
      ];

      const reviewOptions = [
        { name: 'Seleccione Encuesta de Revisión', value: null },
        ...(reviewResponse.data?.data?.surveys || []).map((survey) => (
          { name: survey.title, value: survey.id }
        )),
      ];

      setExecutionSurveyOptions([...executionOptions]);
      setReviewSurveyOptions([...reviewOptions]);
    };
    requestSearch();
  }, []);
  const handleSelectPage = useCallback((event) => {
    const [type, identifier] = event.currentTarget.id.split('-');
    if (type === 'null') return;
    setSelectedPage(identifier);
  }, []);

  const handleAddSection = useCallback(() => {
    setPages((prev) => [
      ...prev,
      {
        identifier: `${prev.length + 1}`,
        hiddenIdentifier: `${prev.length + 1}`,
        type: null,
      },
    ]);
  }, []);

  useEffect(() => {
    setSurveyLabel({
      name: t('task.taskForm.withoutLabel'),
      value: '',
    });
    setIsSurveyTeleaudit({
      name: t('task.taskEdition.revisionPolicy.placeholder'),
      value: '',
    });
  }, [t]);

  useEffect(() => {
    if (!projectId && !projectName && !taskName) {
      history.push(taskURLPath);
    }
  }, [projectId, projectName, taskName, history]);

  const handleSwitch = useCallback((event) => {
    const { name, checked } = event.target;

    setPages((prevPages) => {
      const newPages = [...prevPages];

      newPages[name] = {
        ...newPages[name],
        required: checked,
      };

      return newPages;
    });
  }, []);

  const handleSwitchStock = useCallback((event) => {
    const { checked } = event.target;
    setValuesProp((prev) => ({
      ...prev,
      isSwitchStock: checked,
      productInformation: checked ? false : prev.productInformation,
    }));
  }, []);

  const handleSwitchProductInformation = useCallback((event) => {
    const { checked } = event.target;
    setValuesProp((prev) => ({
      isSwitchStock: checked ? false : prev.isSwitchStock,
      productInformation: checked,
    }));
  }, []);

  const onDragEnd = useCallback(({ destination, source }) => {
    if (!destination) return;
    const copiedItems = [...pages];
    for (let i = 0; i < copiedItems.length; i += 1) {
      copiedItems[i].hiddenIdentifier = `${(i + 1)}`;
    }
    const [removed] = copiedItems.splice(source.index, 1);
    copiedItems.splice(destination.index, 0, removed);

    for (let j = 0; j < copiedItems.length; j += 1) {
      // Updates identifier question, ignore informative pages
      copiedItems[j].identifier = `${(j + 1)}`;

      const questionLogicCopiedItem = copiedItems[j].questionLogic;
      if (questionLogicCopiedItem) {
        for (let i = 0; i < questionLogicCopiedItem.length; i += 1) {
          if (questionLogicCopiedItem[i].questionChoiceIdentifier) {
            const newIdToNextQuestion = copiedItems.find(
              (ci) => ci.hiddenIdentifier === questionLogicCopiedItem[i].nextQuestionIdentifier,
            );
            const idQuestion = copiedItems.find(
              (ci) => ci.hiddenIdentifier === questionLogicCopiedItem[i].questionIdentifier,
            );
            if (newIdToNextQuestion && idQuestion) {
              // eslint-disable-next-line max-len
              copiedItems[j].questionLogic[i].nextQuestionIdentifier = newIdToNextQuestion.identifier;
              copiedItems[j].questionLogic[i].questionIdentifier = idQuestion.identifier;
            }
          } else {
            copiedItems[j].questionLogic[i].questionIdentifier = `${(j + 1)}`;
            copiedItems[j].questionLogic[i].nextQuestionIdentifier = `${(j + 2)}`;
          }
        }
      }

      if (copiedItems[j].questionChoices) {
        // Ensure questionChoices are sorted by identifier
        copiedItems[j].questionChoices = copiedItems[j].questionChoices.sort(
          (a, b) => a.identifier - b.identifier,
        );
      }
    }

    const switchStockIndex = copiedItems.findIndex((ci) => ci.isSwitchStock);

    if (switchStockIndex !== -1) {
      setSwitchStock(copiedItems[switchStockIndex].identifier, 10);
    }
    copiedItems.forEach((copiedItem) => {
      delete copiedItem.hiddenIdentifier;
    });
    setPages([
      ...copiedItems,
    ]);
  }, [pages]);

  const handleSaveSurvey = async () => {
    const isInvalidMaxDistance = georeference
      && (maxDistance === ''
        || maxDistance === null
        || Number.isNaN(Number(maxDistance))
        || Number(maxDistance) < 0);
    if (isInvalidMaxDistance) {
      setSeverity('error');
      setMessage(t('task.saveErrors.maxDistanceInvalid'));
      return;
    }

    let revisionPolicyValidator = revisionPolicy.value;
    if (!revisionPolicyValidator) {
      setSeverity('error');
      setMessage(t('task.saveErrors.noRequiresRevision'));
      return;
    }

    if (valuesProp.isSwitchStock && switchStock == null) {
      setSeverity('error');
      setMessage(t('task.saveErrors.switchStockRequiredQuestion'));
      return;
    }

    const missingGuidelineIndex = pages.findIndex(
      (page) => [IMAGE, MULTIPLE_IMAGE_QUESTION].includes(page.type)
        && page.aiAnalysisRequired
        && !page.guideline?.trim(),
    );
    if (missingGuidelineIndex !== -1) {
      setSeverity('error');
      setMessage(`${t('task.saveErrors.aiAnalysisGuidelineRequired')} ${missingGuidelineIndex + 1}`);
      return;
    }

    const longGuidelineIndex = pages.findIndex(
      (page) => [IMAGE, MULTIPLE_IMAGE_QUESTION].includes(page.type)
        && page.aiAnalysisRequired
        && page.guideline?.trim().length > 255,
    );
    if (longGuidelineIndex !== -1) {
      setSeverity('error');
      setMessage(`${t('task.saveErrors.aiAnalysisGuidelineTooLong')} ${longGuidelineIndex + 1}`);
      return;
    }

    const questionTypesFixed = [];
    const questionGuidelinesToCreate = [];

    let position = 0;
    let validator = 0;

    pages.forEach((page) => {
      if (validator !== 0) return;
      position += 1;

      if (!page.type) return;

      page.position = position;
      page.categoryId = page.categoryId ?? null;
      validator = questionValidator(page, formType.name);
      if (validator !== 0) {
        setSeverity('error');
        switch (validator) {
          case 1:
            setMessage(`${t('task.saveErrors.title')} ${position}`);
            break;
          case 2:
            setMessage(`${t('task.saveErrors.binaryKpis')} ${position}`);
            break;
          case 4:
            setMessage(`${t('task.saveErrors.correctQuestionChoices')} ${position}`);
            break;
          default:
            setMessage(`${t('task.saveErrors.questionChoices')} ${position}`);
            break;
        }
        return;
      }

      if (revisionPolicyValidator !== 'yes') {
        if ([IMAGE, MULTIPLE_IMAGE_QUESTION, VIDEO].includes(page.type)) {
          if (page.requiresTeleaudit) {
            revisionPolicyValidator = 'yes';
          }
        }
      }
      page.isSwitchStock = page.identifier === switchStock;

      if (page.type === VIDEO) {
        page.videoQuality = page.videoQuality || 'medium';
        page.minMemory = page.memoryQuantity && page.memoryUnit ? `${page.memoryQuantity} ${page.memoryUnit}` : null;
      } else {
        page.minMemory = page.memoryQuantity && page.memoryUnit ? `${page.memoryQuantity} ${page.memoryUnit}` : null;
        page.videoQuality = null;
      }

      page.surveyTeleauditId = page.surveyTeleauditId || null;
      page.selectedQuestionOption = page.selectedQuestionOption || null;

      if (
        [IMAGE, MULTIPLE_IMAGE_QUESTION].includes(page.type)
        && page.aiAnalysisRequired
      ) {
        questionGuidelinesToCreate.push({
          identifier: `${page.identifier}`,
          guideline: page.guideline,
          // A single-image question can only ever capture one picture.
          nMinPictures: page.type === IMAGE ? 1 : page.nMinPictures,
        });
      }

      delete page.memoryQuantity;
      delete page.memoryUnit;
      delete page.hiddenIdentifier;
      delete page.guideline;
      delete page.nMinPictures;
      // Descarta las filas de relleno que deja el modal de conexiones y las
      // repetidas por alternativa, igual que al editar.
      page.questionLogic = normalizeQuestionLogic(page.questionLogic);
      questionTypesFixed.push(page);
    });
    if (validator === 0) {
      if (createButtonBlocked) return;
      createButtonBlocked = true;
      const surveyResp = isSurveyTeleaudit.value === 'yes';
      const createSurveyResponse = await postNewSurvey({
        title: inputValues.title,
        questions: questionTypesFixed,
        projectId: project.value,
        type: formType.name,
        requiredGeoreference: georeference,
        revisionPolicy: revisionPolicyValidator,
        vertical: formType.name === PRODUCT ? true : verticalForm,
        switchStock: valuesProp.isSwitchStock,
        productInformation: valuesProp.productInformation,
        label: surveyLabel.value,
        surveyTeleauditId: null,
        surveyTeleaudit: surveyResp,
        maxDistance: georeference && maxDistance !== '' && maxDistance !== null
          ? Number.parseInt(maxDistance, 10)
          : null,
        needReview: needReview.value,
        executionSurveyId: executionSurveyId.value,
        reviewSurveyId: reviewSurveyId.value,
        aiAnalysisRequired,
      });

      if (createSurveyResponse.success) {
        if (questionGuidelinesToCreate.length > 0) {
          const createdQuestions = createSurveyResponse?.data?.data?.newQuestions || [];
          await Promise.all(questionGuidelinesToCreate.map((guidelineToCreate) => {
            const createdQuestion = createdQuestions.find(
              (question) => `${question.questionIdentifier}` === guidelineToCreate.identifier,
            );
            if (!createdQuestion) return null;
            return createQuestionGuideline({
              questionId: createdQuestion.questionId,
              guideline: guidelineToCreate.guideline,
              nMinPictures: guidelineToCreate.nMinPictures,
            });
          }));
        }

        setSeverity('success');
        setMessage(t('task.messages.success.taskCreate'));
        const newId = createSurveyResponse?.data?.data?.dataValues?.id;
        if (newId) {
          sleep(1000).then(() => history.push(`${taskURLPath}/${newId}`));
        } else {
          sleep(1000).then(() => history.push(taskURLPath));
        }
      } else {
        setSeverity('error');
        setMessage(t('task.messages.error.taskCreate'));
      }
      createButtonBlocked = false;
    }
  };

  // const handleGeneralView = () => {
  //   setGeneralView((prevState) => !prevState);
  // };

  const handleViewQuestion = useCallback((event) => {
    const { id } = event.currentTarget;
    if (id === viewDetail) {
      setViewDetail(null);
      return;
    }
    setViewDetail(id);
  }, [viewDetail]);

  const handleOpenConfigs = useCallback(() => {
    setOpenConfigs((prev) => !prev);
  }, []);

  const handleDeleteQuestion = useCallback((event) => {
    const { id } = event.currentTarget;

    // La pregunta de switch stock se guarda por identificador, así que hay que
    // moverla junto con la renumeración.
    if (switchStock != null) {
      setSwitchStock(remapIdentifierAfterDelete(switchStock, id));
    }

    setPages(removeQuestionAndRewireLogic(pages, id));
  }, [pages, switchStock]);

  const handleDuplicateQuestion = useCallback((event) => {
    const { id } = event.currentTarget;
    const question = pages.find((p) => `${p.identifier}` === `${id}`);

    if (question) {
      const newQuestion = {
        ...question,
        identifier: `${pages.length + 1}`,
        hiddenIdentifier: `${pages.length + 1}`,
        position: `${pages.length + 1}`,
        // La copia va al final y arranca sin conexiones propias, pero con una
        // fila por defecto: el modal de conexiones lee `questionLogic[0]`.
        questionLogic: [
          {
            questionIdentifier: `${pages.length + 1}`,
            questionChoiceIdentifier: null,
            nextQuestionIdentifier: `${pages.length + 2}`,
          },
        ],
        questionChoices: question.questionChoices
          ? question.questionChoices.map((choice) => ({ ...choice }))
          : question.questionChoices,
      };

      delete newQuestion.databaseId;
      if (newQuestion.questionChoices) {
        for (let i = 0; i < newQuestion.questionChoices.length; i += 1) {
          delete newQuestion.questionChoices[i].id;
        }
      }

      setPages([...pages, newQuestion]);
    }
  }, [pages]);

  const handleCreateConnections = useCallback(() => {
    let errors = '';
    pages.forEach((page) => {
      const identifier = page.identifier === 0 ? 1 : page.identifier;
      const validator = questionValidator(page, formType.name);
      if (validator !== 0) {
        setSeverity('error');
        switch (validator) {
          case 1:
            errors += `${t('task.saveErrors.title')} ${identifier}\n`;
            break;
          case 2:
            errors += `${t('task.saveErrors.binaryKpis')} ${identifier}\n`;
            break;
          case 4:
            errors += `${t('task.saveErrors.correctQuestionChoices')} ${identifier}\n`;
            break;
          case 5:
            errors += `${t('task.saveErrors.questionType')} ${identifier}\n`;
            break;
          default:
            errors += `${t('task.saveErrors.questionChoices')} ${identifier}\n`;
            break;
        }
      }
    });

    if (errors === '') {
      setOpenConnections(true);
    } else {
      setMessage(errors);
    }
  }, [pages, formType.name, t]);

  const handleVerticalForm = useCallback(() => {
    if (!verticalForm) {
      if (pages.find((p) => p.type === RESUME_PAGE)) {
        handleDeleteQuestion({
          currentTarget: { id: pages.find((p) => p.type === RESUME_PAGE).identifier },
        });
      }
    }
    setVerticalForm(!verticalForm);
  }, [verticalForm, pages, handleDeleteQuestion]);

  return (
    <>
      <div className={styles.content}>
        <div className={styles.headerContainer}>
          <div className={styles.header}>
            <TextField
              value={inputValues.title}
              onChange={useCallback((e) => setInputValues((prev) => ({
                ...prev, title: e.target.value,
              })), [])}
            />
            <p>
              {project?.name}
            </p>
          </div>
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <div className={styles.buttonsContainer}>
                <Button
                  onClick={handleCreateConnections}
                  disabled={pages.length < 2
                    || (pages.length === 2 && !pages[1].type)
                    || !pages[pages.length - 1].type}
                >
                  {t('task.questionLogic.connections')}
                </Button>
              </div>
            </Grid>
            <Grid item>
              <div className={styles.buttonsContainer}>
                <Button
                  onClick={handleOpenConfigs}
                >
                  {t('task.taskEdition.settings')}
                </Button>
              </div>
            </Grid>
            <Grid item>
              <div className={styles.buttonsContainer}>
                <Button
                  onClick={handleSaveSurvey}
                  disabled={formType.name !== INVENTORY
                    && pages.length === 1 && !pages[0].type}
                >
                  {t('task.taskEdition.manageButton')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
        <Divider />
        <div className={styles.surveyContent}>
          <div className={styles.editionArea}>
            {formType.value === 'product' ? (
              <div>
                <FormControlLabel
                  control={
                    <Switch
                      name='is_switch_stock'
                      className={styles.switch}
                      onChange={handleSwitchStock}
                      checked={valuesProp.isSwitchStock}
                      disabled={pages.findIndex((p) => p.type === YES_NO_QUESTION) === -1
                        || valuesProp.productInformation}
                    />
                  }
                  label={t('task.taskEdition.stockSwitch')}
                />
                <FormControlLabel
                  control={
                    <Switch
                      name='product_information'
                      className={styles.switch}
                      onChange={handleSwitchProductInformation}
                      checked={valuesProp.productInformation}
                      disabled={valuesProp.isSwitchStock}
                    />
                  }
                  label={t('task.taskEdition.productInformationSwitch')}
                />
              </div>
            ) : null}
            <CategoryOptionsProvider>
              <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable-list">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {pages.map((page, index) => (
                      <Draggable draggableId={`${index}`} index={index} key={index}>
                        {(prov) => (
                          <div
                            id={`${page.type}-${index}`}
                            onClick={handleSelectPage}
                            ref={prov.innerRef}
                            {...prov.draggableProps}
                            {...prov.dragHandleProps}
                          >
                            <ExpandLess
                              className={clsx(styles.hideContent, {
                                [styles.selectedPageArrows]:
                                  selectedPage === `${index}` && generalView && !(viewDetail === `${index}`),
                              })}
                            />
                            <div
                              className={clsx(styles.pageInfo, {
                                [styles.selectedPageGeneralView]:
                                  selectedPage === `${index}` && generalView && !(viewDetail === `${index}`),
                                [styles.generalViewPageTitle]:
                                  generalView && !(viewDetail === `${index}`),
                              })}
                            >
                              <div>
                                {generalView && <DragIndicator />}
                                <p className={styles.pageTitle}>
                                  {t('task.taskEdition.page')} {index + 1}
                                  {page.type ? `: ${page.name}` : ''}
                                </p>
                              </div>
                              <div>
                                {page.type && generalView ? (
                                  <>
                                    <Edit fontSize="small" />
                                    <Button
                                      id={index}
                                      onClick={handleViewQuestion}
                                    >
                                      <VisibilityOutlined className={styles.viewQuestion} />
                                    </Button>
                                  </>
                                ) : null}
                                {page.type && !generalView
                                  && ![
                                    WELCOME_PAGE, END_PAGE, CONTENT, RESUME_PAGE,
                                  ].includes(page.type)
                                  ? (
                                    <>
                                      <p className={styles.pageTitle}>{t('task.taskEdition.obligatory')}</p>
                                      <FormControlLabel
                                        control={
                                          <Switch name={`${index}`} className={styles.switch} onChange={handleSwitch} checked={!!page.required} />
                                        }
                                        label=""
                                      />
                                    </>
                                  ) : null}
                              </div>
                            </div>
                            <ExpandMore
                              className={clsx(styles.hideContent, {
                                [styles.selectedPageArrows]:
                                  selectedPage === `${index}` && generalView && !(viewDetail === `${index}`),
                              })}
                            />
                            <div
                              className={clsx({
                                [styles.selectedPageStyle]:
                                  selectedPage === `${index}`,
                                [styles.hideContent]:
                                  generalView && !(viewDetail === `${index}`),
                              })}
                            >
                              {([WELCOME_PAGE, END_PAGE, CONTENT].includes(page.type))
                                && <WelcomePage
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                />
                              }
                              {page.type === USER_SELECTION && (
                                <UserSelection
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  setPages={setPages}
                                />
                              )}
                              {page.type === RESUME_PAGE && (
                                <ResumePage
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                />
                              )}
                              {page.type === SIMPLE_SELECTION && (
                                <SimpleSelection
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  setPages={setPages}
                                />
                              )}
                              {page.type === MULTIPLE_SELECTION && (
                                <MultipleSelection
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  setPages={setPages}
                                />
                              )}
                              {page.type === SHORT_ANSWER && (
                                <ShortAnswer
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  setPages={setPages}
                                />
                              )}
                              {page.type === FORMATTED_ANSWER && (
                                <FormattedAnswer
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  setPages={setPages}
                                />
                              )}
                              {page.type === LONG_ANSWER && (
                                <LongAnswer
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  setPages={setPages}
                                />
                              )}
                              {page.type === DROP_DOWN_MENU && (
                                <DropDownMenu
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  setPages={setPages}
                                />
                              )}
                              {page.type === SATISFACTION && (
                                <Satisfaction
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  editMode={false}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                />
                              )}
                              {page.type === IMAGE && (
                                <ImagesAnswer
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  questionOptions={teleauditQuestionOptions}
                                  surveyAiAnalysisRequired={aiAnalysisRequired}
                                />
                              )}
                              {page.type === YES_NO_QUESTION && (
                                <YesNoQuestion
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  switchStock={switchStock}
                                  setSwitchStock={setSwitchStock}
                                  isSwitchStock={valuesProp.isSwitchStock}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                />
                              )}
                              {page.type === DATE && (
                                <DateAnswer
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  setPages={setPages}
                                />
                              )}
                              {page.type === NUMERIC_ANSWER && (
                                <NumericAnswer
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  setPages={setPages}
                                />
                              )}
                              {page.type === DECIMAL_ANSWER && (
                                <DecimalAnswer
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  setPages={setPages}
                                />
                              )}
                              {page.type === NPS_QUESTION && (
                                <NpsQuestion
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                />
                              )}
                              {page.type === MULTIPLE_IMAGE_QUESTION && (
                                <MultipleImageQuestion
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  questionOptions={teleauditQuestionOptions}
                                  surveyAiAnalysisRequired={aiAnalysisRequired}
                                />
                              )}
                              {page.type === SIGNATURE_QUESTION && (
                                <SignatureQuestion
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                />
                              )}
                              {page.type === BARCODE_QUESTION && (
                                <BarcodeQuestion
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                />
                              )}
                              {page.type === PRICE && (
                                <Price
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                />
                              )}
                              {page.type === VIDEO && (
                                <Video
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                  questionOptions={teleauditQuestionOptions}
                                />
                              )}
                              {([AUDIO, AUDIO_BACKGROUND].includes(page.type)) && (
                                <Audio
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                />
                              )}
                              {page.type === TIME && (
                                <Time
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={handleDuplicateQuestion}
                                />
                              )}
                              {!page.type && (
                                <SelectPage
                                  setPages={setPages}
                                  pages={pages}
                                  formType={formType}
                                  identifier={page.identifier}
                                  setSwitchStock={setSwitchStock}
                                  verticalForm={verticalForm}
                                />
                              )}
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
              </DragDropContext>
            </CategoryOptionsProvider>
            <Button
              className={styles.button}
              onClick={handleAddSection}
            >
              {t('task.taskEdition.addPageButton')}
            </Button>
          </div>
        </div>
        {openConnections ? (
          <QuestionLogic
            open={openConnections}
            setOpen={setOpenConnections}
            inputValues={pages}
            setInputValues={setPages}
            edit={false}
            view={false}
          />
        ) : null}
        {openConfigs
          ? <TaskSettings
            open={openConfigs}
            setOpen={setOpenConfigs}
            georeference={georeference}
            setGeoreference={setGeoreference}
            aiAnalysisRequired={aiAnalysisRequired}
            setAiAnalysisRequired={setAiAnalysisRequired}
            revisionPolicy={revisionPolicy}
            setRevisionPolicy={setRevisionPolicy}
            verticalForm={verticalForm}
            handleVerticalForm={handleVerticalForm}
            formType={formType}
            surveyLabel={surveyLabel}
            setSurveyLabel={setSurveyLabel}
            isSurveyTeleaudit={isSurveyTeleaudit}
            setIsSurveyTeleaudit={setIsSurveyTeleaudit}
            maxDistance={maxDistance}
            setMaxDistance={setMaxDistance}
            needReview={needReview}
            setNeedReview={setNeedReview}
            executionSurveyId={executionSurveyId}
            setExecutionSurveyId={setExecutionSurveyId}
            reviewSurveyId={reviewSurveyId}
            setReviewSurveyId={setReviewSurveyId}
            executionSurveyOptions={executionSurveyOptions}
            reviewSurveyOptions={reviewSurveyOptions}
          />
          : null}
        <Snackbar
          open={message !== ''}
          message={message}
          severity={severity}
          onClose={() => setMessage('')}
        />
      </div>
    </>
  );
}

export default CreateTask;
